import React, { useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { Sidebar } from '../components/Layout/Sidebar'
import Topbar from '../components/Layout/Topbar'
import ManageDeliveryForm from '../components/ManageDelivery/ManageDeliveryForm'
import { useSelector } from 'react-redux'
import { supabase } from '../supabase.config'
import { createUserNotifications, emitOrderNotification } from '../utils/notificationService'

const ManageDelivery = () => {

	const { error, loading } = useSelector(
		(state) => state.order
	)
	const { isAuthenticated, users, userProfile } = useSelector(
		(state) => state.user
	)
  const actorUserId = userProfile?.id || userProfile?.uid || users || null
	const [orderActivity, setorderActivity] = useState([])
	const [user, setUser] = useState({})
	const [userList, setUserList] = useState([])
	const [lrNumber, setLrNumber] = useState("")
	const [orderList, setOrderList] = useState([])
	const [lrNolist, setLrNolist] = useState([])
	const [orderDetails, setOrderDetail] = useState({})
	const [vehicileNo, setVehicileNo] = useState("")
  const getOrderRow = async (ident) => {
    const uuidRe = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
    if (uuidRe.test(String(ident))) {
      const { data, error } = await supabase.from('orders').select('*').eq('id', ident).single()
      if (!error && data) return data
    }

    let res = await supabase.from('orders').select('*').eq('order_number', ident).single()
    if (!res.error && res.data) return res.data

    res = await supabase.from('orders').select('*').eq('order_id', ident).single()
    if (!res.error && res.data) return res.data

    res = await supabase.from('orders').select('*').eq('tracking_number', ident).single()
    if (!res.error && res.data) return res.data

    return null
  }
	const handleDeliveryBoy = async () => {
		const date = new Date();

		// Validation checks
		if (user.length === 0 || vehicileNo.length === 0) {
			toast.error("Please fill all the fields");
			return;
		}

		if (lrNolist.length === 0) {
			toast.error("Please Add lr No");
			return;
		}

    try {
        // Iterate over lr numbers and update each order
        for (const lrno of lrNolist) {
            const current = await getOrderRow(lrno)
            if (!current) continue
            const isRedeliveryAttempt = current.status === 'Out for Delivery'
            const nextStatus = isRedeliveryAttempt ? 'Reattempted Delivery' : 'Out for Delivery'
            const pkg = (typeof current.package_details === 'object') ? current.package_details : (()=>{ try{return JSON.parse(current.package_details||'{}')}catch{return {}}})()
            const updatedPkg = {
                ...pkg,
                orderActivity: [...(pkg.orderActivity || []), {
                    status: nextStatus,
                    remark: isRedeliveryAttempt ? 'Order marked for reattempted delivery' : 'Order moved out for delivery',
                    location: isRedeliveryAttempt ? 'Reattempted delivery initiated' : 'Order moved out for delivery',
                    time: date
                }]
            }
            await supabase.from('orders').update({ status: nextStatus, package_details: updatedPkg }).eq('id', current.id)
            await emitOrderNotification({
              actorUserId,
              order: { ...current, status: nextStatus, package_details: updatedPkg },
              recipientUserIds: [user?.id],
              eventType: isRedeliveryAttempt ? 'order_redelivery_attempt' : 'order_out_for_delivery',
              title: isRedeliveryAttempt ? 'Order moved to reattempted delivery' : 'Order moved to delivery',
              message: `Order ${current?.tracking_number || current?.order_number || current?.order_id || ''} is now ${isRedeliveryAttempt ? 'in reattempted delivery' : 'out for delivery'}.`,
              metadata: { assignedTo: user?.name || user?.email || '' },
            })
        }

        // Try to record a delivery assignment if table exists
        const insertPayload = {
            created_at: new Date(),
            // Use assigned_user to avoid reserved keyword issues
            assigned_user: user,
            lr_numbers: lrNolist,
            vehicle_no: vehicileNo,
            status: 'Delivery Pending'
        }
        const { error: insertError } = await supabase
          .from('delivery_boy_data')
          .insert([insertPayload])
        if (insertError) {
          console.error('Failed to insert delivery_boy_data', insertError, insertPayload)
          toast.error('Failed to save delivery assignment')
        }

      await createUserNotifications({
        recipientUserIds: [user?.id],
        actorUserId,
        eventType: 'delivery_assignment_created',
        title: 'New delivery assignment',
        message: `You have been assigned ${lrNolist.length} order(s) for delivery.`,
        entityType: 'delivery_assignment',
        metadata: {
          vehicleNo: vehicileNo,
          lrNumbers: lrNolist,
        },
      })

			toast.success("Delivery Boy Added Successfully");
			window.location.reload();
		} catch (error) {
			toast.error("Failed to process: " + error.message);
		}
	};


	console.log(lrNolist)
	const handleLrNoData = (selectedValue) => {
		setLrNolist((prevList) => {
      if (!selectedValue || prevList.includes(selectedValue)) {
        return prevList;
      }
			const updatedList = [...prevList, selectedValue];
			return updatedList;
		});
		setLrNumber("");
	};

  const handleScannedBarcode = async (scannedValue) => {
    const normalizedValue = String(scannedValue || '').trim()
    if (!normalizedValue) {
      return
    }

    const current = await getOrderRow(normalizedValue)
    if (!current?.order_number) {
      toast.error('No matching order found for scanned barcode')
      return
    }

    setLrNolist((prevList) => {
      if (prevList.includes(current.order_number)) {
        return prevList
      }
      return [...prevList, current.order_number]
    })
    setLrNumber("")
    toast.success(`Added ${current.order_number} to order bundle`)
  }

	console.log(lrNolist)
	const removelrno = (lrNumber) => {
		setLrNolist((prevList) =>
			prevList.filter((item) =>
				typeof item === "object" ? item.lrno !== lrNumber.lrno : item !== lrNumber
			)
		);
	};



    const fetchOrder = async () => {
        const { data, error } = await supabase
            .from('orders')
            .select('*')
            .in('status', ['in-transit', 'pickedUp', 'Out for Delivery'])
            .order('created_at', { ascending: false })
        if (error) return
        const rows = (data || [])
          .filter(r => !!r.order_number)
          .map(r => ({ id: r.id, order_number: r.order_number, orderStatus: r.status }))
        setOrderList(rows)
    }

	console.log(orderList)

    const fetchUser = async () => {
        const { data, error } = await supabase.from('users').select('*').in('role', ['Delivery Boy','Delivery Partner']).eq('service','logistics')
        if (error) return
        const list = (data || []).map(u => ({ id: u.id, name: u.name, phone: u.contact, email: u.email }))
        setUserList(list)
    }

	console.log(userList)

	useEffect(() => {
		if (Object.keys(user).length === 0) {
			fetchUser()
		}
		fetchOrder()
	}, [user])
	console.log(orderList)

	useEffect(() => {
		
		fetchOrder()
	}, [])

	return (
		<div className='flex bg-slate-100/80' >
			<Toaster />
			<Sidebar />
			<div className='flex h-[100vh] flex-1 flex-col overflow-y-scroll' >
				<Topbar />
				<ManageDeliveryForm vehicileNo={vehicileNo} setVehicileNo={setVehicileNo} handleDeliveryBoy={handleDeliveryBoy} user={user} setUser={setUser} userList={userList} setUserList={setUserList} setOrderList={setOrderList} orderList={orderList} lrNumber={lrNumber} setLrNumber={setLrNumber} handleLrNoData={handleLrNoData} handleScannedBarcode={handleScannedBarcode} lrNolist={lrNolist} removelrno={removelrno} />
			</div>
		</div>
	)
}

export default ManageDelivery
